// import React, { useEffect, useState } from "react";
// import SideMenu from "../components/SideMenu";
// import Header from "../components/Header";
// import UserMenu from "../components/UserMenu";
// import TokenRegistrationTable from "../components/TokenRegistrationTable";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Radio,
//   RadioGroup,
//   FormControl,
//   FormLabel,
// } from "@mui/material";
// import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { Box } from "@mui/material";
// import axios from "axios";
// import API_BASE_URL from "../utilities/ApiConfig";
// import { toast } from "react-toastify";
// import formatDate from "../utilities/formatDate";
// import ApiLoader from "../components/ApiLoader";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { clearUsers } from "../redux-store/slices/partyDetailsSlice";
// import DummyModal from "../Modal/DummyModal";

// const RegistrationTokenList = () => {
//   const [tokenList, setTokenList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedCheckbox, setSelectedCheckbox] = useState(null);
//   const [partyDetailsMode, setPartyDetailsMode] = useState("ALL");
//   const [meetingLink, setMeetingLink] = useState("");
//   const [selectedTokenDetails, setSelectedTokenDetails] = useState([]);
//   const [modifyModalOpen, setModifyModalOpen] = useState(false);
//   const [modifyModalData, setModifyModalData] = useState(null);
//   const [propertyEvalModData, setPropertyEvalModData] = useState(null);
//   // const [partyDetailMod, setPartyDetailMod] = useState(null);

//   const [selectedItems, setSelectedItems] = useState({});

//   const [partyListDetailsPopup, setPartyListDetailsPopup] = useState(false);
//   const [registeredPartyList, setRegisteredPartyList] = useState([]);
//   const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const [partyDetailMod, setPartyDetailMod] = useState({
//     savefirstparty: [],
//     savesecondparty: [],
//     savewitness: [],
//   });

//   const updatePartyInState = (updatedRowData) => {
//     setPartyDetailMod((prevState) => ({
//       ...prevState,
//       savefirstparty: prevState.savefirstparty.map((party) =>
//         party.pcode === updatedRowData.pcode
//           ? { ...party, ...updatedRowData, updated: true }
//           : party
//       ),
//       savesecondparty: prevState.savesecondparty.map((party) =>
//         party.pcode === updatedRowData.pcode
//           ? { ...party, ...updatedRowData, updated: true }
//           : party
//       ),
//       savewitness: prevState.savewitness.map((party) =>
//         party.pcode === updatedRowData.pcode
//           ? { ...party, ...updatedRowData, updated: true }
//           : party
//       ),
//     }));
//   };

//   const selectedPartyDetailsArray = Object.keys(selectedItems)
//     .filter((pcode) => selectedItems[pcode])
//     .map((pcode) => registeredPartyList.find((item) => item.pcode === pcode));

//   console.log(
//     "selected party data for postponed mode",
//     selectedPartyDetailsArray
//   );

//   const handleGetRegisteredTokenData = async () => {
//     try {
//       setLoading(true);
//       debugger;

//       // // Clear the existing meeting link from session storage
//       // sessionStorage.removeItem("meetingLink");

//       // Fetch deed details
//       const response = await axios.get(
//         `${API_BASE_URL}/Registration/get_deed_details_modewise_using_dcode_srocode/${dcode}/${srocode}/photo`
//       );
//       console.log("All token list", response.data);

//       if (response.data?.statusCode === 200) {
//         const deedDetailsList = response.data?.deedDetailsList;

//         setTokenList(deedDetailsList);
//       } else {
//         toast.error(response.data?.status || "Failed to fetch deed details.");
//       }
//     } catch (error) {
//       console.error("Error fetching registered token data:", error);
//       toast.error("Unexpected error occurred. Cannot fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGetPartyDetailsUsingParameters = async (tokenDetails) => {
//     try {
//       debugger;
//       setLoading(true);
//       const response = await axios.get(
//         `${API_BASE_URL}/Registration/get_party_details_modewise_using_dcode_srocode_token_date_token_no/${dcode}/${srocode}/${tokenDetails.tokenDate}/${tokenDetails.tokenNo}/ALL`
//       );
//       console.log("Registered party list details", response.data);
//       if (response.data?.statusCode === 200) {
//         setRegisteredPartyList(response.data?.registeredPartyDetailsList);
//         // debugger;
//         // setPartyDetailsListFound(true);
//         // alert(`postponed mode selected ${partyDetailsMode}`);
//         setPartyListDetailsPopup(true);
//       } else {
//         toast.error(response.data?.status);
//       }
//     } catch (error) {
//       console.log("handle party details error", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleView = async (Pde) => {
//     debugger;
//     setLoading(true);
//     try {
//       const propertyDetailsUrl = `${API_BASE_URL}/ModifyPDE/GetPropertyDetails/${Pde}`;
//       const propertyEvalUrl = `${API_BASE_URL}/ModifyPDE/GetPropertyEvaluationModify/${Pde}`;
//       const partyDetailUrl = `${API_BASE_URL}/ModifyPDE/Get_partyDetails_Modify/${Pde}`;

//       const [
//         propertyDetailsResponse,
//         propertyEvalResponse,
//         partyDetailResponse,
//       ] = await Promise.all([
//         axios.get(propertyDetailsUrl),
//         axios.get(propertyEvalUrl),
//         axios.get(partyDetailUrl),
//       ]);

//       console.log("Property Details:", propertyDetailsResponse.data);
//       console.log("Property Evaluation Details:", propertyEvalResponse.data);
//       console.log("Party Details:", partyDetailResponse.data);
//       debugger;
//       setModifyModalData(propertyDetailsResponse.data.data[0]);
//       setPropertyEvalModData(propertyEvalResponse.data.data[0]);
//       setPartyDetailMod(partyDetailResponse.data);

//       setModifyModalOpen(true);
//     } catch (err) {
//       toast.error("Failed to Load Data.");
//     } finally {
//       setLoading(false); // Set loading to false after the request is done, regardless of success or failure
//     }
//   };

//   const handleRedirectToThumbPhotoAndSignaturePage = async (tokenNo) => {
//     debugger;
//     // console.log('pdEid',pdEid)
//     const pdEid = tokenNo.pdEid;
//     const appointmentType = tokenNo.appointmentType;
//     debugger;
//     setSelectedItems({});
//     // Fetch the meeting link
//     if (appointmentType === "V") {
//       const meetRes = await axios.get(
//         `${API_BASE_URL}/Registration/get_meeting_Link?PDE_ID=${pdEid}`
//       );

//       if (meetRes.status === 200) {
//         const meetingLink = meetRes?.data?.meetinglink;

//         // Set meeting link in state and session storage
//         if (meetingLink) {
//           setMeetingLink(meetingLink);
//           sessionStorage.setItem("meetingLink", meetingLink);
//         }
//       }
//     }
//     console.log("token no ", appointmentType);
//     console.log("pdEid no ", pdEid);
//     const selectedTokenDetails = tokenList.filter((token) => {
//       return token.tokenNo === tokenNo.tokenNo;
//     });
//     console.log("selected token details", selectedTokenDetails);
//     setSelectedTokenDetails(selectedTokenDetails);
//     console.log("all token list", tokenList);
//     if (partyDetailsMode !== "POSTPONED") {
//       if (selectedTokenDetails.length > 0 && appointmentType !== "V") {
//         debugger;
//         navigate("/PhotoThumbSignForm", {
//           state: { selectedTokenDetails, mode: partyDetailsMode },
//         });
//       } else if (appointmentType === "V") {
//         debugger;

//         debugger;
//         navigate("/WebexForm", {
//           state: { selectedTokenDetails, mode: partyDetailsMode },
//         });
//       }
//     } else {
//       handleGetPartyDetailsUsingParameters(selectedTokenDetails[0]);
//       // alert(`postponed mode selected ${partyDetailsMode}`);
//     }
//   };

//   const handleRedirectToPostponedRegistrationTokenPage = async () => {
//     navigate("/PostponedRegistrationTokenList");
//   };

//   const TableData = tokenList?.map((item, index) => ({
//     ...item,
//     sn: index + 1,
//   }));
//   console.log("TableData", TableData);

//   const columns = [
//     // {
//     //     name: "sn",
//     //     label: "Serial No",
//     //     options: {
//     //         filter: false,
//     //         sort: true,
//     //         customBodyRender: (value) => <div className="text-center">{value}</div>
//     //     }
//     // },

//     {
//       name: "tokenNo",
//       label: "Token No",
//       options: {
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => <div className="text-start">{value}</div>,
//       },
//     },
//     {
//       name: "tokenDate",
//       label: "Token Date",
//       options: {
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => <div className="text-start">{value}</div>,
//       },
//     },
//     {
//       name: "regYear",
//       label: "Registration Year",
//       options: {
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => (
//           <div className="text-start">{formatDate(value, "dd/MM/yyyy")}</div>
//         ),
//       },
//     },
//     {
//       name: "deed",
//       label: "Deed",
//       options: {
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => <div className="text-start">{value}</div>,
//       },
//     },

//     {
//       name: "subDeed",
//       label: "Sub Deed",
//       options: {
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => <div className="text-start">{value}</div>,
//       },
//     },
//     {
//       name: "appointmentType",
//       label: "appointment Type",
//       options: {
//         display: true,
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => <div className="text-start">{value}</div>,
//       },
//     },
//     {
//       name: "pdEid",
//       label: "PDE ID",
//       options: {
//         display: true,
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => <div className="text-start">{value}</div>,
//       },
//     },
//     // {
//     //   name: "pdEid",
//     //   label: "DOCUMENT",
//     //   options: {
//     //     // display: true,
//     //     filter: false,
//     //     sort: true,

//     //     customBodyRender: (value) => (
//     //       <button
//     //         className="capitalize px-5 py-1 text-start cursor-pointer text-blue-500"
//     //         onClick={handleView(String(value))}
//     //       >
//     //         View
//     //       </button>
//     //     ),
//     //   },
//     // },
//     {
//       name: "pdEid",
//       label: "DOCUMENT",
//       options: {
//         filter: false,
//         sort: true,
//         customBodyRender: (value) => (
//           <button
//             className="capitalize px-5 py-1 text-start cursor-pointer text-primary"
//             onClick={() => handleView(String(value))}
//           >
//             Modify
//           </button>
//         ),
//       },
//     },

//     {
//       name: "pdEid",
//       label: "ACTION",
//       options: {
//         filter: false,
//         sort: true,
//         customBodyRender: (pdEid, tableMeta) => {
//           const tokenNo = tableMeta.rowData[0]; // Assuming 'tokenNo' is the first column
//           const appointmentType = tableMeta.rowData[5]; // Assuming 'tokenNo' is the first column
//           return (
//             <button
//               className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
//               onClick={() =>
//                 handleRedirectToThumbPhotoAndSignaturePage({
//                   tokenNo,
//                   pdEid,
//                   appointmentType,
//                 })
//               }
//             >
//               Verify
//             </button>
//           );
//         },
//       },
//     },
//   ];

//   const options = {
//     selectableRows: "none",
//     filterType: "dropdown",
//     elevation: 0,
//     rowsPerPageOptions: [10, 15, 25, 50],
//     responsive: "standard",
//     tableBodyHeight: "auto",
//     tableBodyMaxHeight: "auto",
//     download: false, // Disables the default download (CSV export) button
//     print: false, // Disables the default print button
//     viewColumns: false, // Disables the default view columns button
//     search: true, // Enables the default search button
//     customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
//   };

//   const getMuiTheme = () =>
//     createTheme({
//       typography: {
//         fontFamily: "Poppins",
//       },
//       palette: {
//         background: {
//           paper: "#ffffff",
//           default: "#ffffff",
//         },
//         mode: "light",
//       },
//       components: {
//         MuiTableCell: {
//           styleOverrides: {
//             head: {
//               backgroundColor: "#ffffff !important",
//               color: "#929292 !important",
//               padding: "10px 4px",
//               borderBottom: "2px solid #ECECEC",
//               borderRight: "0px solid #ddd",
//               textAlign: "start",
//               "& .MuiTableSortLabel-root": {
//                 color: "#000000 !important",
//                 "&.MuiTableSortLabel-active": {
//                   color: "#000000 !important",
//                 },
//               },
//               "& .MuiTableSortLabel-icon": {
//                 color: "#000000 !important",
//               },
//               "&:hover": {
//                 color: "#000000 !important",
//                 backgroundColor: "#ffffff !important",
//               },
//             },
//             body: {
//               padding: "7px 15px",
//               color: "#000000",
//               borderBottom: "0px solid #ECECEC",
//               borderRight: "0px solid #000000",
//             },
//             footer: {
//               padding: "7px 15px",
//               borderBottom: "0px solid #ECECEC",
//             },
//           },
//         },
//       },
//     });

//   const handleCheckboxChange = (event) => {
//     const { name } = event.target;
//     const value = event.target.value;

//     if (selectedCheckbox === name) {
//       setSelectedCheckbox(null);
//       setPartyDetailsMode("ALL");
//     } else {
//       setSelectedCheckbox(name);
//       setPartyDetailsMode(value);
//       console.log("name:", name, "value:", value);
//     }
//     console.log("party details mode", partyDetailsMode);
//   };

//   const handleApprovePartyListDetails = () => {
//     // debugger;
//     if (selectedPartyDetailsArray.length > 0) {
//       navigate("/PhotoThumbSignForm", {
//         state: {
//           selectedTokenDetails,
//           mode: partyDetailsMode,
//           partyListData: selectedPartyDetailsArray,
//         },
//       });
//       setPartyListDetailsPopup(false);
//     } else {
//       toast.error("Please Select Party Members");
//     }
//   };

//   const handleClosePartyListDetails = () => {
//     setPartyListDetailsPopup(false);
//   };

//   const handlePartyDetailsCheckboxChange = (pcode) => {
//     setSelectedItems((prev) => ({
//       ...prev,
//       [pcode]: !prev[pcode], // Toggle the selected state
//     }));
//     console.log("selected items", selectedItems);
//   };

//   useEffect(() => {
//     dispatch(clearUsers());
//     setSelectedCheckbox(null);
//     setPartyDetailsMode("ALL");
//     handleGetRegisteredTokenData();
//   }, []);

//   useEffect(() => {
//     console.log("party details mode", partyDetailsMode);
//   }, [partyDetailsMode]);

//   return (
//     <>
//       {loading && <ApiLoader />}

//       <div className="flex h-screen">
//         <SideMenu />
//         <div className="flex-1 flex flex-col">
//           <Header />
//           <div className="flex flex-1">
//             <div className="flex-1 p-4">
//               <h1 className="font-semibold text-xl">Registration Token</h1>
//               <div className="flex">
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={selectedCheckbox === "book4_2nd_party"}
//                       onChange={handleCheckboxChange}
//                       name="book4_2nd_party"
//                       value="SECOND"
//                     />
//                   }
//                   label="Book No.4 2nd Party Not Present"
//                 />
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={selectedCheckbox === "book1_1st_party"}
//                       onChange={handleCheckboxChange}
//                       name="book1_1st_party"
//                       value="FIRST"
//                     />
//                   }
//                   label="Book No.1 1st Party Not Present"
//                 />
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={selectedCheckbox === "postponed_document"}
//                       onChange={handleCheckboxChange}
//                       name="postponed_document"
//                       value="POSTPONED"
//                     />
//                   }
//                   label="Postponed Document"
//                 />
//               </div>
//               <div className="flex">
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={selectedCheckbox === "book1_2nd_party"}
//                       onChange={handleCheckboxChange}
//                       name="book1_2nd_party"
//                       value="SECOND"
//                     />
//                   }
//                   label="Book No.1 2nd Party Not Present"
//                 />
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={selectedCheckbox === "book6_2nd_party"}
//                       onChange={handleCheckboxChange}
//                       name="book6_2nd_party"
//                       value="SECOND"
//                     />
//                   }
//                   label="Book No.6 2nd Party Not Present"
//                 />
//                 <button
//                   className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
//                   onClick={() => {
//                     handleRedirectToPostponedRegistrationTokenPage();
//                   }}
//                 >
//                   Postponed Tokens
//                 </button>
//               </div>

//               <div>
//                 <Box width="100%">
//                   <ThemeProvider theme={getMuiTheme()}>
//                     <MUIDataTable
//                       title={"Imported Token"}
//                       data={TableData}
//                       columns={columns}
//                       options={options}
//                     />
//                   </ThemeProvider>
//                 </Box>
//               </div>
//             </div>

//             <div className="w-64 h-full">
//               <UserMenu />
//             </div>
//           </div>
//         </div>
//       </div>
//       {modifyModalOpen && (
//         <DummyModal
//           isOpen={modifyModalOpen}
//           onclose={() => setModifyModalOpen(false)}
//           modifyData={modifyModalData}
//           propertyEvalMod={propertyEvalModData}
//           partyDetailMod={partyDetailMod}
//           updatePartyInState={updatePartyInState}

//           // onSuccess={handleMobileVerificationSuccess}
//         />
//       )}

//       {/* <Dialog
//         open={partyListDetailsPopup}
//         onClose={handleApprovePartyListDetails}
//       >
//         <DialogTitle className="bg-gray-800 text-white">
//           Popup Title
//         </DialogTitle>
//         <DialogContent className="bg-white p-4 px-10">
//           <div className="p-6 bg-gray-100 text-lg font-semibold text-gray-800 rounded-lg shadow-md mb-4">
//             <div>
//               <span>Token No : {selectedTokenDetails[0]?.tokenNo}</span> &nbsp;
//               <span>Token Date : {selectedTokenDetails[0]?.tokenDate}</span>
//             </div>

//             <div>
//               {registeredPartyList.map((item, index) => (
//                 <div key={index} className="flex items-center mb-4">
//                   <label className="flex items-center">
//                     <input
//                       type="checkbox"
//                       className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
//                       checked={!!selectedItems[item.pcode]}
//                       onChange={() =>
//                         handlePartyDetailsCheckboxChange(item.pcode)
//                       }
//                     />
//                     <span className="ml-2 text-lg font-semibold text-gray-800">
//                       <span className="text-blue-600">
//                         {item.nameEng}({item.pcode})
//                       </span>
//                     </span>
//                   </label>
//                 </div>
//               ))}

//               <div>
//                 <h2 className="text-xl font-bold mt-4 mb-2">
//                   Selected Parties:
//                 </h2>
//                 {selectedPartyDetailsArray.length === 0 ? (
//                   <p>No parties selected.</p>
//                 ) : (
//                   selectedPartyDetailsArray.map((item, index) => (
//                     <div key={index} className="flex items-center mb-2">
//                       <span className="text-lg font-semibold text-gray-800">
//                         <span className="text-blue-600">
//                           {item.nameEng}({item.pcode})
//                         </span>
//                       </span>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>
//           </div>
//         </DialogContent>
//         <DialogActions className="bg-gray-100">
//           <Button
//             onClick={handleClosePartyListDetails}
//             className="bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded"
//           >
//             Close
//           </Button>
//           <Button
//             onClick={handleApprovePartyListDetails}
//             className="bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded"
//           >
//             RedirectToPhotoThumbSign
//           </Button>
//         </DialogActions>
//       </Dialog> */}
//       {/* <Dialog
//         open={partyListDetailsPopup}
//         onClose={handleApprovePartyListDetails}
//         fullWidth
//         maxWidth={false} // Disable Material UI's default width limit
//         className="!w-[1000px] mx-auto"
//       >
//         <DialogTitle className="bg-[#CAE5FF] text-primary-black justify-between items-center">
//           Select Party Who are Present
//         </DialogTitle>
//         <DialogContent className="bg-white p-6">
//           <div className="p-6 bg-gray-100 text-lg font-semibold text-secondary-800 rounded-lg shadow-md mb-4">
//             <div>
//               <span>Token No : {selectedTokenDetails[0]?.tokenNo}</span> &nbsp;
//               <span>Token Date : {selectedTokenDetails[0]?.tokenDate}</span>
//             </div>

//             <div>
//               {registeredPartyList.map((item, index) => (
//                 <div key={index} className="flex items-center mb-4">
//                   <label className="flex items-center">
//                     <input
//                       type="checkbox"
//                       className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
//                       checked={!!selectedItems[item.pcode]}
//                       onChange={() =>
//                         handlePartyDetailsCheckboxChange(item.pcode)
//                       }
//                     />
//                     <span className="ml-2 text-lg font-semibold text-gray-800">
//                       <span className="text-blue-600">
//                         {item.nameEng}({item.pcode})
//                       </span>
//                     </span>
//                   </label>
//                 </div>
//               ))}

//               <div>
//                 <h2 className="text-xl font-bold mt-4 mb-2">
//                   Selected Parties:
//                 </h2>
//                 {selectedPartyDetailsArray.length === 0 ? (
//                   <p>No parties selected.</p>
//                 ) : (
//                   selectedPartyDetailsArray.map((item, index) => (
//                     <div key={index} className="flex items-center mb-2">
//                       <span className="text-lg font-semibold text-gray-800">
//                         <span className="text-blue-600">
//                           {item.nameEng}({item.pcode})
//                         </span>
//                       </span>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>
//           </div>
//         </DialogContent>
//         <DialogActions className="bg-gray-100">
//           <Button
//             onClick={handleClosePartyListDetails}
//             className="bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded"
//           >
//             Close
//           </Button>
//           <Button
//             onClick={handleApprovePartyListDetails}
//             className="bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded"
//           >
//             RedirectToPhotoThumbSign
//           </Button>
//         </DialogActions>
//       </Dialog> */}

//       <Dialog
//         open={partyListDetailsPopup}
//         onClose={handleApprovePartyListDetails}
//         fullWidth
//         maxWidth={false}
//         className="!w-[1000px] mx-auto"
//       >
//         <DialogTitle className="bg-[#CAE5FF] text-primary-black justify-between items-center">
//           Select Party Who are Present
//         </DialogTitle>
//         <DialogContent className="bg-white p-6 px-12">
//           <div className="p-6 bg-gray-100 text-lg font-semibold text-gray-800 rounded-lg shadow-md mb-4">
//             <div>
//               <span>Token No : {selectedTokenDetails[0]?.tokenNo}</span> &nbsp;
//               <span>Token Date : {selectedTokenDetails[0]?.tokenDate}</span>
//             </div>

//             <div className="grid grid-cols-2 gap-6">
//               {" "}
//               {/* Divided into two columns */}
//               {registeredPartyList.map((item, index) => (
//                 <div key={index} className="flex items-center mb-4">
//                   <label className="flex items-center">
//                     <input
//                       type="checkbox"
//                       className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
//                       checked={!!selectedItems[item.pcode]}
//                       onChange={() =>
//                         handlePartyDetailsCheckboxChange(item.pcode)
//                       }
//                     />
//                     <span className="ml-2 text-lg font-semibold text-gray-800">
//                       <span className="text-blue-600">
//                         {item.nameEng}({item.pcode})
//                       </span>
//                     </span>
//                   </label>
//                 </div>
//               ))}
//             </div>

//             <div>
//               <h2 className="text-xl font-bold mt-4 mb-2">Selected Parties:</h2>
//               {selectedPartyDetailsArray.length === 0 ? (
//                 <p>No parties selected.</p>
//               ) : (
//                 <div className="grid grid-cols-2 gap-6">
//                   {" "}
//                   {/* Divided into two columns */}
//                   {selectedPartyDetailsArray.map((item, index) => (
//                     <div key={index} className="flex items-center mb-2">
//                       <span className="text-lg font-semibold text-gray-800">
//                         <span className="text-blue-600">
//                           {item.nameEng}({item.pcode})
//                         </span>
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         </DialogContent>
//         <DialogActions className="bg-gray-100">
//           <Button
//             onClick={handleClosePartyListDetails}
//             className="!bg-danger-500 !hover:bg-red-700 !text-white py-1 px-3 rounded"
//           >
//             Close
//           </Button>
//           <Button
//             onClick={handleApprovePartyListDetails}
//             className="!bg-primary hover:bg-red-700 !text-white py-1 px-3 rounded"
//           >
//             Proceed
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default RegistrationTokenList;

import React, { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import TokenRegistrationTable from "../components/TokenRegistrationTable";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  TableCell,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import formatDate from "../utilities/formatDate";
import ApiLoader from "../components/ApiLoader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUsers } from "../redux-store/slices/partyDetailsSlice";
import DummyModal from "../Modal/DummyModal";
import ModifyModal from "../Modal/ModifyModal";

const RegistrationTokenList = () => {
  const [tokenList, setTokenList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [partyDetailsMode, setPartyDetailsMode] = useState("ALL");
  const [meetingLink, setMeetingLink] = useState("");
  const [selectedTokenDetails, setSelectedTokenDetails] = useState([]);
  const [modifyModalOpen, setModifyModalOpen] = useState(false);
  const [modifyModalData, setModifyModalData] = useState(null);
  const [propertyEvalModData, setPropertyEvalModData] = useState(null);
  // const [partyDetailMod, setPartyDetailMod] = useState(null);

  const [selectedItems, setSelectedItems] = useState({});

  const [partyListDetailsPopup, setPartyListDetailsPopup] = useState(false);
  const [registeredPartyList, setRegisteredPartyList] = useState([]);
  const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);

  const [videoMeetingModalOpen, setVideoMeetingModalOpen] = useState(false);
  const [videoMeetingStatus, setVideoMeetingStatus] = useState(""); // 'yes' or 'no'
  const [videoMeetingTokenData, setVideoMeetingTokenData] = useState(null);

  debugger;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [partyDetailMod, setPartyDetailMod] = useState({
    savefirstparty: [],
    savesecondparty: [],
    savewitness: [],
  });

  const updatePartyInState = (updatedRowData) => {
    setPartyDetailMod((prevState) => ({
      ...prevState,
      savefirstparty: prevState.savefirstparty.map((party) =>
        party.pcode === updatedRowData.pcode
          ? { ...party, ...updatedRowData, updated: true }
          : party
      ),
      savesecondparty: prevState.savesecondparty.map((party) =>
        party.pcode === updatedRowData.pcode
          ? { ...party, ...updatedRowData, updated: true }
          : party
      ),
      savewitness: prevState.savewitness.map((party) =>
        party.pcode === updatedRowData.pcode
          ? { ...party, ...updatedRowData, updated: true }
          : party
      ),
    }));
  };

  const selectedPartyDetailsArray = Object.keys(selectedItems)
    .filter((pcode) => selectedItems[pcode])
    .map((pcode) => registeredPartyList.find((item) => item.pcode === pcode));

  console.log(
    "selected party data for postponed mode",
    selectedPartyDetailsArray
  );

  const handleGetRegisteredTokenData = async () => {
    try {
      setLoading(true);
      debugger;

      // // Clear the existing meeting link from session storage
      // sessionStorage.removeItem("meetingLink");

      // Fetch deed details
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_deed_details_modewise_using_dcode_srocode/${dcode}/${srocode}/photo`
      );
      console.log("All token list", response.data);
      debugger;
      if (response.data?.statusCode === 200) {
        const deedDetailsList = response.data?.deedDetailsList;

        setTokenList(deedDetailsList);
        debugger;
      } else {
        toast.error(response.data?.status || "Failed to fetch deed details.");
      }
    } catch (error) {
      console.error("Error fetching registered token data:", error);
      toast.error("Unexpected error occurred. Cannot fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handleGetPartyDetailsUsingParameters = async (tokenDetails) => {
    try {
      debugger;
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_party_details_modewise_using_dcode_srocode_token_date_token_no/${dcode}/${srocode}/${tokenDetails.tokenDate}/${tokenDetails.tokenNo}/ALL`
      );
      console.log("Registered party list details", response.data);
      if (response.data?.statusCode === 200) {
        setRegisteredPartyList(response.data?.registeredPartyDetailsList);
        // debugger;
        // setPartyDetailsListFound(true);
        // alert(`postponed mode selected ${partyDetailsMode}`);
        setPartyListDetailsPopup(true);
      } else {
        toast.error(response.data?.status);
      }
    } catch (error) {
      console.log("handle party details error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (Pde) => {
    debugger;
    setLoading(true);
    try {
      const propertyDetailsUrl = `${API_BASE_URL}/ModifyPDE/GetPropertyDetails/${Pde}`;
      const propertyEvalUrl = `${API_BASE_URL}/ModifyPDE/GetPropertyEvaluationModify/${Pde}`;
      const partyDetailUrl = `${API_BASE_URL}/ModifyPDE/Get_partyDetails_Modify/${Pde}`;

      const [
        propertyDetailsResponse,
        propertyEvalResponse,
        partyDetailResponse,
      ] = await Promise.all([
        axios.get(propertyDetailsUrl),
        axios.get(propertyEvalUrl),
        axios.get(partyDetailUrl),
      ]);

      console.log("Property Details:", propertyDetailsResponse.data);
      console.log("Property Evaluation Details:", propertyEvalResponse.data);
      console.log("Party Details:", partyDetailResponse.data);
      debugger;
      setModifyModalData(propertyDetailsResponse.data.data[0]);
      setPropertyEvalModData(propertyEvalResponse.data.data[0]);
      setPartyDetailMod(partyDetailResponse.data);

      setModifyModalOpen(true);
    } catch (err) {
      toast.error("Failed to Load Data.");
    } finally {
      setLoading(false); // Set loading to false after the request is done, regardless of success or failure
    }
  };

  const handleRedirectToThumbPhotoAndSignaturePage = async (tokenData) => {
    debugger;

    const { appointmentType, bookNo, pdEid, tokenDate, tokenNo } = tokenData;
    debugger;
    setSelectedItems({});

    console.log("token no ", appointmentType);
    console.log("pdEid no ", pdEid);
    const selectedTokenDetails = tokenList.filter((token) => {
      return token.tokenNo === tokenData.tokenNo;
    });
    console.log("selected token details", selectedTokenDetails);
    setSelectedTokenDetails(selectedTokenDetails);
    console.log("all token list", tokenList);
    if (partyDetailsMode !== "POSTPONED") {
      debugger;
      if (selectedTokenDetails.length > 0 && appointmentType !== "V") {
        debugger;
        navigate("/PhotoThumbSignForm", {
          state: { selectedTokenDetails, mode: partyDetailsMode },
        });
      } else if (appointmentType === "V") {
        debugger;
        const flagReq = {
          pdeId: pdEid,
        };
        const flagRes = await axios.post(
          `${API_BASE_URL}/VideoMeetingStatus/get-video-meeting-flag`,
          flagReq
        );
        debugger;
        if (flagRes.data.statusCode === 201) {
          const meetRes = await axios.get(
            `${API_BASE_URL}/Registration/get_meeting_Link?PDE_ID=${pdEid}`
          );

          if (meetRes.status === 200) {
            const meetingLink = meetRes?.data?.meetinglink;

            // Set meeting link in state and session storage
            if (meetingLink) {
              setMeetingLink(meetingLink);
              sessionStorage.setItem("meetingLink", meetingLink);
            }
          } else {
            toast.error("Error Fetching meeitng link");
          }
        } else if (flagRes.data.statusCode === 200) {
          setVideoMeetingTokenData({
            selectedTokenDetails,
            pdEid,
          });
          setVideoMeetingModalOpen(true);
          return;
        } else {
          toast.error("Error Fetching Meeting Status");
        }

        debugger;
        navigate("/WebexForm", {
          state: { selectedTokenDetails, mode: partyDetailsMode, pdEid },
        });
      }
    } else {
      debugger;
      handleGetPartyDetailsUsingParameters(selectedTokenDetails[0]);
      // alert(`postponed mode selected ${partyDetailsMode}`);
    }
  };

  const handleRedirectToPostponedRegistrationTokenPage = async () => {
    navigate("/PostponedRegistrationTokenList");
  };

  const TableData = tokenList?.map((item, index) => ({
    ...item,
    sn: index + 1,
  }));
  console.log("TableData", TableData);

  // const columns = [
  //   {
  //     name: "tokenNo",
  //     label: "Token No",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },
  //   {
  //     name: "tokenDate",
  //     label: "Token Date",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },
  //   {
  //     name: "regYear",
  //     label: "Registration Year",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => (
  //         <div className="text-start">{formatDate(value, "dd/MM/yyyy")}</div>
  //       ),
  //     },
  //   },
  //   {
  //     name: "deed",
  //     label: "Deed",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },

  //   {
  //     name: "subDeed",
  //     label: "Sub Deed",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },
  //   {
  //     name: "appointmentType",
  //     label: "appointment Type",
  //     options: {
  //       display: true,
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },
  //   {
  //     name: "pdEid",
  //     label: "PDE ID",
  //     options: {
  //       display: true,
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },

  //   {
  //     name: "bookNo",
  //     label: "bookNo",
  //     options: {
  //       display: false,
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },

  //   {
  //     name: "pdEid",
  //     label: "DOCUMENT",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => (
  //         <button
  //           className="capitalize px-5 py-1 text-start cursor-pointer text-primary"
  //           onClick={() => handleView(String(value))}
  //         >
  //           Review/Modify
  //         </button>
  //       ),
  //     },
  //   },

  //   {
  //     name: "pdEid",
  //     label: "ACTION",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (pdEid, tableMeta) => {
  //         debugger;
  //         const tokenNo = tableMeta.rowData[0];
  //         const tokenDate = tableMeta.rowData[1];
  //         const regYear = tableMeta.rowData[2];
  //         const appointmentType = tableMeta.rowData[5];
  //         const bookNo = tableMeta.rowData[7];

  //         return (
  //           <button
  //             className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
  //             onClick={() =>
  //               handleRedirectToThumbPhotoAndSignaturePage({
  //                 tokenNo,
  //                 tokenDate,
  //                 regYear,
  //                 appointmentType,
  //                 bookNo,
  //                 pdEid,
  //               })
  //             }
  //           >
  //             Verify
  //           </button>
  //         );
  //       },
  //     },
  //   },
  // ];

  // const options = {
  //   selectableRows: "none",
  //   filterType: "dropdown",
  //   elevation: 0,
  //   rowsPerPageOptions: [10, 15, 25, 50],
  //   responsive: "standard",
  //   tableBodyHeight: "auto",
  //   tableBodyMaxHeight: "auto",
  //   download: false, // Disables the default download (CSV export) button
  //   print: false, // Disables the default print button
  //   viewColumns: false, // Disables the default view columns button
  //   search: true, // Enables the default search button
  //   customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
  // };

  // const getMuiTheme = () =>
  //   createTheme({
  //     typography: {
  //       fontFamily: "Poppins",
  //     },
  //     palette: {
  //       background: {
  //         paper: "#ffffff",
  //         default: "#ffffff",
  //       },
  //       mode: "light",
  //     },
  //     components: {
  //       MuiTableCell: {
  //         styleOverrides: {
  //           head: {
  //             backgroundColor: "#ffffff !important",
  //             color: "#929292 !important",
  //             padding: "10px 4px",
  //             borderBottom: "2px solid #ECECEC",
  //             borderRight: "0px solid #ddd",
  //             textAlign: "start",
  //             "& .MuiTableSortLabel-root": {
  //               color: "#000000 !important",
  //               "&.MuiTableSortLabel-active": {
  //                 color: "#000000 !important",
  //               },
  //             },
  //             "& .MuiTableSortLabel-icon": {
  //               color: "#000000 !important",
  //             },
  //             "&:hover": {
  //               color: "#000000 !important",
  //               backgroundColor: "#ffffff !important",
  //             },
  //           },
  //           body: {
  //             padding: "7px 15px",
  //             color: "#000000",
  //             borderBottom: "0px solid #ECECEC",
  //             borderRight: "0px solid #000000",
  //           },
  //           footer: {
  //             padding: "7px 15px",
  //             borderBottom: "0px solid #ECECEC",
  //           },
  //         },
  //       },
  //     },
  //   });

  // 1. Base header style (unchanged except uppercase)
  const headerCellSx = {
    fontFamily: "Poppins",
    textTransform: "uppercase",
    backgroundColor: "#ffffff",
    color: "#929292",
    borderBottom: "2px solid #ECECEC",
    padding: "10px 4px",
    fontSize: "0.875rem",
    whiteSpace: "nowrap",
    minWidth: "140px",
  };

  // 2. Narrower Token No
  const narrowHeaderCellSx = {
    ...headerCellSx,
    minWidth: "80px",
  };

  // 3. Wider Sub Deed
  const wideHeaderCellSx = {
    ...headerCellSx,
    minWidth: "200px",
  };

  const columns = [
    {
      name: "tokenNo",
      label: "Token No",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={narrowHeaderCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <div style={{ whiteSpace: "nowrap" }} className="text-center">
            {value}
          </div>
        ),
      },
    },
    {
      name: "tokenDate",
      label: "Token Date",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => <div className="text-center">{value}</div>,
      },
    },
    {
      name: "regYear",
      label: "Registration Year",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <div className="text-center">{formatDate(value, "dd/MM/yyyy")}</div>
        ),
      },
    },
    {
      name: "deed",
      label: "Deed",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => <div className="text-center">{value}</div>,
      },
    },
    {
      name: "subDeed",
      label: "Sub Deed",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={wideHeaderCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <Box
            sx={{
              whiteSpace: "normal",
              overflowWrap: "break-word",
              wordBreak: "normal",
              textAlign: "center",
              px: 1,
            }}
          >
            {value}
          </Box>
        ),
      },
    },
    {
      name: "appointmentType",
      label: "Appointment Type",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => <div className="text-center">{value}</div>,
      },
    },
    {
      name: "pdEid",
      label: "PDE ID",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <div style={{ whiteSpace: "nowrap" }} className="text-center">
            {value}
          </div>
        ),
      },
    },
    {
      name: "bookNo",
      label: "Book No",
      options: {
        display: false,
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => <div className="text-center">{value}</div>,
      },
    },
    {
      name: "pdEid",
      label: "DOCUMENT",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <button
            style={{ whiteSpace: "nowrap" }}
            className="capitalize px-5 py-1 text-center cursor-pointer text-primary"
            onClick={() => handleView(String(value))}
          >
            Review/Modify
          </button>
        ),
      },
    },
    {
      name: "pdEid",
      label: "ACTION",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (pdEid, tableMeta) => {
          const [tokenNo, tokenDate, regYear, appointmentType, bookNo] =
            tableMeta.rowData;

          return (
            <button
              className="capitalize px-5 py-1 text-center text-sm rounded-md cursor-pointer bg-primary-600 text-white"
              onClick={() =>
                handleRedirectToThumbPhotoAndSignaturePage({
                  tokenNo,
                  tokenDate,
                  regYear,
                  appointmentType,
                  bookNo,
                  pdEid,
                })
              }
            >
              Verify
            </button>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false, // Disables the default download (CSV export) button
    print: false, // Disables the default print button
    viewColumns: false, // Disables the default view columns button
    search: true, // Enables the default search button
    customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
  };

  // 3. Update your theme to center all header cells by default
  const getMuiTheme = () =>
    createTheme({
      typography: { fontFamily: "Poppins" },
      palette: {
        background: { paper: "#ffffff", default: "#ffffff" },
        mode: "light",
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              whiteSpace: "nowrap",
              backgroundColor: "#ffffff !important",
              color: "#929292 !important",
              padding: "10px 4px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              textAlign: "center", // <-- center headers
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#000000 !important",
                backgroundColor: "#ffffff !important",
              },
            },
            body: {
              padding: "7px 15px",
              color: "#000000",
              borderBottom: "0px solid #ECECEC",
              borderRight: "0px solid #000000",
              textAlign: "center", // <-- center body cells
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
              textAlign: "center", // <-- center footer if needed
            },
          },
        },
      },
    });

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    const value = event.target.value;

    if (selectedCheckbox === name) {
      setSelectedCheckbox(null);
      setPartyDetailsMode("ALL");
    } else {
      setSelectedCheckbox(name);
      setPartyDetailsMode(value);
      console.log("name:", name, "value:", value);
    }
    console.log("party details mode", partyDetailsMode);
  };

  const handleApprovePartyListDetails = () => {
    // debugger;
    if (selectedPartyDetailsArray.length > 0) {
      navigate("/PhotoThumbSignForm", {
        state: {
          selectedTokenDetails,
          mode: partyDetailsMode,
          partyListData: selectedPartyDetailsArray,
        },
      });
      setPartyListDetailsPopup(false);
    } else {
      toast.error("Please Select Party Members");
    }
  };

  const handleClosePartyListDetails = () => {
    setPartyListDetailsPopup(false);
  };

  const handlePartyDetailsCheckboxChange = (pcode) => {
    setSelectedItems((prev) => ({
      ...prev,
      [pcode]: !prev[pcode], // Toggle the selected state
    }));
    console.log("selected items", selectedItems);
  };

  useEffect(() => {
    dispatch(clearUsers());
    setSelectedCheckbox(null);
    setPartyDetailsMode("ALL");
    handleGetRegisteredTokenData();
  }, []);

  useEffect(() => {
    console.log("party details mode", partyDetailsMode);
  }, [partyDetailsMode]);

  return (
    <>
      {loading && <ApiLoader />}

      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            <div className="flex-1 p-4">
              <h1 className="font-semibold text-xl">Registration Token</h1>
              <div className="flex">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book4_2nd_party"}
                      onChange={handleCheckboxChange}
                      name="book4_2nd_party"
                      value="SECOND"
                    />
                  }
                  label="Book No.4 2nd Party Not Present"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book1_1st_party"}
                      onChange={handleCheckboxChange}
                      name="book1_1st_party"
                      value="FIRST"
                    />
                  }
                  label="Book No.1 1st Party Not Present"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "postponed_document"}
                      onChange={handleCheckboxChange}
                      name="postponed_document"
                      value="POSTPONED"
                    />
                  }
                  label="Postponed Document"
                />
              </div>
              <div className="flex">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book1_2nd_party"}
                      onChange={handleCheckboxChange}
                      name="book1_2nd_party"
                      value="SECOND"
                    />
                  }
                  label="Book No.1 2nd Party Not Present"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCheckbox === "book6_2nd_party"}
                      onChange={handleCheckboxChange}
                      name="book6_2nd_party"
                      value="SECOND"
                    />
                  }
                  label="Book No.6 2nd Party Not Present"
                />
                <button
                  className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
                  onClick={() => {
                    handleRedirectToPostponedRegistrationTokenPage();
                  }}
                >
                  Postponed Tokens
                </button>
              </div>

              <div>
                <Box width="100%">
                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      title={"Imported Token"}
                      data={TableData}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>
                </Box>
              </div>
            </div>

            <div className="w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
      {modifyModalOpen && (
        <ModifyModal
          isOpen={modifyModalOpen}
          onclose={() => setModifyModalOpen(false)}
          modifyData={modifyModalData}
          propertyEvalMod={propertyEvalModData}
          partyDetailMod={partyDetailMod}
          updatePartyInState={updatePartyInState}

          // onSuccess={handleMobileVerificationSuccess}
        />
      )}

      <Dialog
        open={videoMeetingModalOpen}
        onClose={() => setVideoMeetingModalOpen(false)}
      >
        <DialogTitle>Is Video Meeting Completed?</DialogTitle>
        <DialogContent>
          <FormControl>
            <FormLabel>Choose an option</FormLabel>
            <RadioGroup
              value={videoMeetingStatus}
              onChange={(e) => setVideoMeetingStatus(e.target.value)}
              row
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setVideoMeetingModalOpen(false)} color="error">
            Cancel
          </Button>
          <Button
            onClick={async () => {
              setVideoMeetingModalOpen(false);
              const { selectedTokenDetails, pdEid } = videoMeetingTokenData;

              if (videoMeetingStatus === "no") {
                try {
                  const meetRes = await axios.get(
                    `${API_BASE_URL}/Registration/get_meeting_Link?PDE_ID=${pdEid}`
                  );
                  if (meetRes.status === 200) {
                    const meetingLink = meetRes?.data?.meetinglink;
                    if (meetingLink) {
                      setMeetingLink(meetingLink);
                      sessionStorage.setItem("meetingLink", meetingLink);

                      // ✅ Now navigate after fetching
                      navigate("/WebexForm", {
                        state: {
                          selectedTokenDetails,
                          mode: partyDetailsMode,
                          pdEid,
                        },
                      });
                    }
                  } else {
                    toast.error("Error Fetching meeting link");
                  }
                } catch (error) {
                  toast.error("Error fetching meeting link");
                }
              } else if (videoMeetingStatus === "yes") {
                // ✅ Just show toast, DO NOT navigate
                toast.success("Navigate to required Page");
                navigate("/VirtualRegistrationTokenList", {
                  state: {
                    selectedTokenDetails,
                    mode: "RegistrationVirtual",
                    pdEid,
                  },
                });
              }
            }}
            variant="contained"
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={partyListDetailsPopup}
        onClose={handleApprovePartyListDetails}
        fullWidth
        maxWidth={false}
        className="!w-[1000px] mx-auto"
      >
        <DialogTitle className="bg-[#CAE5FF] text-primary-black justify-between items-center">
          Select Party Who are Present
        </DialogTitle>
        <DialogContent className="bg-white p-6 px-12">
          <div className="p-6 bg-gray-100 text-lg font-semibold text-gray-800 rounded-lg shadow-md mb-4">
            <div>
              <span>Token No : {selectedTokenDetails[0]?.tokenNo}</span> &nbsp;
              <span>Token Date : {selectedTokenDetails[0]?.tokenDate}</span>
            </div>

            <div className="grid grid-cols-2 gap-6">
              {" "}
              {/* Divided into two columns */}
              {registeredPartyList.map((item, index) => (
                <div key={index} className="flex items-center mb-4">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      checked={!!selectedItems[item.pcode]}
                      onChange={() =>
                        handlePartyDetailsCheckboxChange(item.pcode)
                      }
                    />
                    <span className="ml-2 text-lg font-semibold text-gray-800">
                      <span className="text-blue-600">
                        {item.nameEng}({item.pcode})
                      </span>
                    </span>
                  </label>
                </div>
              ))}
            </div>

            <div>
              <h2 className="text-xl font-bold mt-4 mb-2">Selected Parties:</h2>
              {selectedPartyDetailsArray.length === 0 ? (
                <p>No parties selected.</p>
              ) : (
                <div className="grid grid-cols-2 gap-6">
                  {" "}
                  {/* Divided into two columns */}
                  {selectedPartyDetailsArray.map((item, index) => (
                    <div key={index} className="flex items-center mb-2">
                      <span className="text-lg font-semibold text-gray-800">
                        <span className="text-blue-600">
                          {item.nameEng}({item.pcode})
                        </span>
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions className="bg-gray-100">
          <Button
            onClick={handleClosePartyListDetails}
            className="!bg-danger-500 !hover:bg-red-700 !text-white py-1 px-3 rounded"
          >
            Close
          </Button>
          <Button
            onClick={handleApprovePartyListDetails}
            className="!bg-primary hover:bg-red-700 !text-white py-1 px-3 rounded"
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RegistrationTokenList;
